"use client";

import React from "react";
import { ArrowRight, Cog, Factory } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const linkCards = [{
  title: "Related Services",
  description: "Explore our complete lifecycle support, equipment qualification, preventive maintenance, and technical calibration for regulated laboratory workflows.",
  url: "/ServicesPage",
  cta: "View all services",
  icon: Cog
}, {
  title: "Related Industries",
  description: "Discover tailored analytical instrumentation and validation solutions for pharmaceutical, biopharmaceutical, environmental, and academic sectors.",
  url: "/IndustriesPage",
  cta: "Explore industries",
  icon: Factory
}];
export default function RelatedLinks() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="relatedlinks" data-nav="light" className="bg-background py-16 md:py-24 border-t border-border">
      <div className="page-container">
        <div className="mx-auto max-w-2xl text-center mb-12">
          <p className="text-xs font-semibold tracking-wider text-primary uppercase mb-2">
            Explore More
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-foreground">
            Connect to Solutions & Expertise
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
          {linkCards.map((card, i) => {
          const IconComponent = card.icon;
          return <motion.div key={card.title} data-index={i} initial={shouldReduceMotion ? {
            opacity: 1
          } : {
            opacity: 0,
            y: 20
          }} whileInView={shouldReduceMotion ? {
            opacity: 1
          } : {
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.15
          }} className="h-full">
                <Card className="h-full flex flex-col justify-between border-t-4 border-t-primary border-x border-b border-border shadow-md hover:shadow-lg transition-shadow bg-card">
                  <CardHeader>
                    <div className="flex items-center gap-3 mb-2">
                      <div className="p-2.5 rounded-lg bg-secondary text-primary inline-flex items-center justify-center">
                        <IconComponent className="size-5" />
                      </div>
                      <CardTitle className="text-xl sm:text-2xl font-bold text-card-foreground">
                        {card.title}
                      </CardTitle>
                    </div>
                    <CardDescription className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                      {card.description}
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="pt-0">
                    {/* Content area placeholder to maintain spacing */}
                  </CardContent>
                  <CardFooter className="pt-2">
                    <Button asChild variant="outline" className="w-full sm:w-auto border-primary/40 hover:border-primary text-foreground hover:bg-primary/10 group">
                      <Link to={card.url} className="inline-flex items-center justify-center gap-2">
                        <span>{card.cta}</span>
                        <ArrowRight className="size-4 transition-transform duration-200 group-hover:translate-x-1 text-primary" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}